import { IMenuDetails } from "./models/menu-details";

import { Yii } from "libraries/interfaces/Yii";
import { INotification, NotificationType } from "libraries/interfaces/INotification";

export const MENU_DETAILS_ITEMS: IMenuDetails[] = [
    {
        code: 'offers',
        name: Yii.t('wui-shared-js', 'Offres'),
        exist: true,
        selected: true,
        permission: 'iqbh.hotel.detail.offer.view',
    },
    {
        code: 'description',
        name: Yii.t('wui-shared-js', 'Descriptions'),
        exist: false,
        selected: false,
        permission: 'iqbh.hotel.detail.description.view',
    },
    {
        code: 'informations',
        name: Yii.t('wui-shared-js', 'Informations pratiques'),
        exist: false,
        selected: false,
        permission: 'iqbh.hotel.detail.information.view',
    }
];

export const MENU_DETAILS_BOOKING_ITEMS: IMenuDetails[] = [
    {
        code: 'description',
        name: Yii.t('wui-shared-js', 'Descriptions'),
        exist: true,
        selected: true
    },
    {
        code: 'informations',
        name: Yii.t('wui-shared-js', 'Informations pratiques'),
        exist: true,
        selected: false
    }
];

export const NOTIFICATIONS: INotification = {
    type: NotificationType.Error,
    active: false,
    message: null
};
